var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "widget-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "widget-options-container"
  }, [_c('div', {
    staticClass: "row-container",
    on: {
      "click": _vm.onToggleTopDonorsNumbersShown
    }
  }, [_c('div', {
    staticClass: "widget-label"
  }, [_vm._v(_vm._s(_vm.$t('show.top')))]), _vm.isDesktop ? _c('div', {
    staticClass: "widget-select"
  }, _vm._l(_vm.topDonorsNumberList, function (topDonorsNumber) {
    return _c('div', {
      key: topDonorsNumber,
      staticClass: "widget-select-item",
      class: {
        active: topDonorsNumber === _vm.widget.topDonorsNumber
      },
      on: {
        "click": function click($event) {
          _vm.widget.topDonorsNumber = topDonorsNumber;
        }
      }
    }, [_vm._v(" " + _vm._s(topDonorsNumber) + " ")]);
  }), 0) : _c('div', {
    staticClass: "widget-select-container"
  }, [_c('div', {
    staticClass: "widget-select-value"
  }, [_vm._v(_vm._s(_vm.widget.topDonorsNumber))]), _c('div', {
    staticClass: "arrow-icon",
    class: {
      'chevron-top-icon': _vm.isShownTopDonorsNumbers,
      'chevron-bottom-icon': !_vm.isShownTopDonorsNumbers
    }
  })])]), _c('transition', {
    attrs: {
      "name": "slide-vertical"
    }
  }, [_vm.isShownTopDonorsNumbers ? _c('div', {
    staticClass: "select-variants-container"
  }, _vm._l(_vm.topDonorsNumberList, function (topDonorsNumber) {
    return _c('div', {
      key: topDonorsNumber,
      staticClass: "select-variant-item",
      class: {
        active: topDonorsNumber === _vm.widget.topDonorsNumber
      },
      on: {
        "click": function click($event) {
          return _vm.onChangeTopDonorsNumber(topDonorsNumber);
        }
      }
    }, [_vm._v(" " + _vm._s(topDonorsNumber) + " ")]);
  }), 0) : _vm._e()])], 1), _c('div', {
    staticClass: "widget-options-container"
  }, [_c('div', {
    staticClass: "row-container",
    on: {
      "click": _vm.onToggleTopDonorsTypesShown
    }
  }, [_c('div', {
    staticClass: "widget-label"
  }, [_vm._v(_vm._s(_vm.$t('in.mode')))]), _vm.isDesktop ? _c('div', {
    staticClass: "widget-select"
  }, _vm._l(_vm.topDonorsTypeList, function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return _c('div', {
      key: key,
      staticClass: "widget-select-item",
      class: {
        active: key === _vm.widget.topDonorsType
      },
      on: {
        "click": function click($event) {
          _vm.widget.topDonorsType = key;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(value)) + " ")]);
  }), 0) : _c('div', {
    staticClass: "widget-select-container"
  }, [_c('div', {
    staticClass: "widget-select-value"
  }, [_vm._v(_vm._s(_vm.$t(_vm.displayTopDonorsType)))]), _c('div', {
    staticClass: "arrow-icon",
    class: {
      'chevron-top-icon': _vm.isShownTopDonorsTypes,
      'chevron-bottom-icon': !_vm.isShownTopDonorsTypes
    }
  })])]), _c('transition', {
    attrs: {
      "name": "slide-vertical"
    }
  }, [_vm.isShownTopDonorsTypes ? _c('div', {
    staticClass: "select-variants-container"
  }, _vm._l(_vm.topDonorsTypeList, function (topDonorsType) {
    return _c('div', {
      key: topDonorsType.key,
      staticClass: "select-variant-item",
      class: {
        active: topDonorsType.key === _vm.widget.topDonorsType
      },
      on: {
        "click": function click($event) {
          return _vm.onChangeTopDonorsType(topDonorsType.key);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(topDonorsType.value)) + " ")]);
  }), 0) : _vm._e()])], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('show.amounts')
    },
    model: {
      value: _vm.widget.showSum,
      callback: function callback($$v) {
        _vm.$set(_vm.widget, "showSum", $$v);
      },
      expression: "widget.showSum"
    }
  })], 1)])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }